import script from "./VVVPayoutManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./VVVPayoutManagement.vue?vue&type=script&setup=true&lang=js"

import "./VVVPayoutManagement.vue?vue&type=style&index=0&id=2f707688&scoped=true&lang=css"
import "./VVVPayoutManagement.vue?vue&type=style&index=1&id=2f707688&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f707688"]])

export default __exports__